import type { NotificationFilterId } from "../filter"
import { screenTexts } from "../localization/screen"

const filters: { id: NotificationFilterId; label: string }[] = [
  { id: "all", label: screenTexts.filters.all },
  { id: "promotions", label: screenTexts.filters.promotions },
  { id: "payments", label: screenTexts.filters.payments }
]

type FiltersProps = {
  selected: NotificationFilterId
  counts: Record<NotificationFilterId, number>
  onSelect: (filter: NotificationFilterId) => void
}

export function Filters({ selected, counts, onSelect }: FiltersProps) {
  return (
    <div className="flex w-full gap-3">
      {filters.map((filter) => {
        const isSelected = filter.id === selected
        const count = counts[filter.id]
        const grow = filter.id === "promotions" ? "flex-[1.2]" : "flex-1"

        return (
          <button
            key={filter.id}
            type="button"
            aria-pressed={isSelected}
            className={`flex h-11 ${grow} cursor-pointer items-center justify-center gap-2 rounded-[10px] border bg-black-800 px-2 text-sm ${
              isSelected
                ? "border-purple-200 text-white"
                : "border-white/10 text-white/50"
            }`}
            onClick={() => onSelect(filter.id)}
          >
            <span>{filter.label}</span>
            {count > 0 ? (
              <span className="inline-flex h-5 min-w-5 shrink-0 items-center justify-center rounded-full bg-purple-500 px-1 text-[11px] font-semibold leading-none text-white">
                {count}
              </span>
            ) : null}
          </button>
        )
      })}
    </div>
  )
}
